import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {map, catchError} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

@Injectable()
export class BackOfficeInvoiceService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getInvoices(gridData = new HttpParams(), params = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/invoice/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getDraftInvoices(gridData = new HttpParams(), params = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/draft-invoice/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getDraftInvoiceTotalCount(scope = 'backoffice'): Observable<number> {
    const params = new HttpParams()
      .set('sortType', 'desc')
      .set('sortBy', 'created')
      .set('filter', encodeURIComponent(JSON.stringify({})))
      .set('status', 'all')
      .set('per_page', '1')
      .set('query', '')
      .set('page', '1');
    return this.http
      .get<any>(environment.apiUrl + '/' + scope + '/draft-invoice/?' + params.toString())
      .pipe(
        map((res) => {
          const raw = res && typeof res.total !== 'undefined' ? Number(res.total) : 0;
          return isNaN(raw) ? 0 : raw;
        }),
        catchError((res) => {
          this.helper.catchError(res);
          return of(0);
        })
      );
  }

   public getDraft(draftInvoiceId, draftInvoiceLogId = null ) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/draft-invoice/' + draftInvoiceId, { params: {log_id: draftInvoiceLogId} })
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public exportInvoices(gridData = new HttpParams(), params = new HttpParams(), scope = 'backoffice') {
    return this.http.get(environment.apiUrl + '/' + scope + '/invoice/export?' + gridData.toString(), {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      catchError(res => this.helper.catchError(res))
    );
  }

  public getPdf(invoiceId: number) {
    return this.http.get(environment.apiUrl + '/backoffice/invoice/' + invoiceId + '/pdf', {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => this.helper.fileDownloadMap(resp, true)),
      catchError(error  => this.helper.catchError(error ))
    );
  }

  public invoiceBulkAction(params) {
    return this.http.post<any>(environment.apiUrl + '/backoffice/invoice/bulk-action', params)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public updateInvoice(invoice, id) {
    return this.http.put<any>(environment.apiUrl + '/backoffice/invoice/' + id + '/partial-paid', {invoice: invoice})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getInvoiceOrders(invoiceId) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/invoice/' + invoiceId + '/orders')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public creditInvoice(invoice, id, isEdit) {
    if (isEdit) {
      return this.http.put<any>(environment.apiUrl + '/backoffice/invoice/' + id + '/edit-credit', {creditInvoice: invoice})
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post<any>(environment.apiUrl + '/backoffice/invoice/' + id + '/add-credit', {creditInvoice: invoice})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public creatCustomInvoice(invoice) {
    return this.http.post<any>(environment.apiUrl + '/backoffice/invoice/add-custom-invoice', {creditInvoice: invoice})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public editCustomInvoice(id,invoice) {
    return this.http.put<any>(environment.apiUrl + '/backoffice/draft-invoice/'+ id, {form : invoice})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public rejectDraftInvoice(draftInvoiceId) {
    return this.http.post<any>(environment.apiUrl + '/backoffice/draft-invoice/'+ draftInvoiceId + '/reject', {})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public approveDraftInvoice(draftInvoiceId) {
    return this.http.post<any>(environment.apiUrl + '/backoffice/draft-invoice/'+ draftInvoiceId + '/approve', {})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getDraftInvoiceLogs(gridData = new HttpParams()) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/draft-invoice-log?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

}
